import script from "./PlayerBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerBlock.vue?vue&type=script&setup=true&lang=js"

import "./PlayerBlock.vue?vue&type=style&index=0&id=19162964&lang=scss"

const __exports__ = script;

export default __exports__